import { ThemeConfig } from "antd";

export const defaultTheme: ThemeConfig = {
  token: { colorPrimary: "#24b3a7", colorLink: "#003d58" },
  components: {
    Badge: {
      colorError: "#24b3a7",
      colorErrorHover: "#24b3a7",
    },
    Progress: {
      defaultColor: "#24b3a7",
    },
  },
};
